import React from "react";
import "./ProductCard.scss";

export default function ProductCard(props) {
  return (
    <div {...props} className={`productcard-external-div ${props?.className || ""}`} >
      <div className="productcard-image-div">
        <img src={props.image} alt={props.title || "product"} />
      </div>
      <div className="productcard-bottom-div">
        <h1 className="productcard-heading">{props.title}</h1>
        <p className="productcard-para productcard-description" title={props.description}>
          {props.description}
        </p>
        <div className="bottom-lower-div">
          <div className="productcard-location">
            <img src={props.icon} alt="location" />
            <span className="productcard-para">{props.map}</span>
          </div>
          <button className="productcard-button">Order now</button>
        </div>
      </div>
    </div>
  );
}
